import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {EventEmitter, Injectable} from '@angular/core';
import {Notification, NotificationService} from '@mydocma/component-library/src/lib/notification';
import {Task, TaskService, TaskStatusEnum} from '@mydocma/task';
import {MmTranslateService} from '../../mm-translate.service';
import {Guid} from 'guid-typescript';
import {ExtendedNotificationComponent} from '../../mm-components/app-container/extended-notification/extended-notification.component';


@UntilDestroy()
@Injectable()
export class FaultsImportTasksService {

  public onRefreshClicked = new EventEmitter<void>();

  importTasks: {[taskId: string]: Task} = {};

  constructor(private readonly taskService: TaskService,
              private translateService: MmTranslateService,
              private readonly notificationService: NotificationService) {

    this.taskService.onTaskChanged
      .pipe(untilDestroyed(this))
      .subscribe(task => {
        if (!this.importTasks.hasOwnProperty(task.id)) {
          return;
        }

        switch (task?.status?.value) {
          case TaskStatusEnum.ended:
            delete this.importTasks[task.id];

            const notification = new Notification<any>();
            notification.id = Guid.create().toString();
            notification.data.push({
              title: this.translateService.instant('MM.fault.import.task.successNotification.title'),
              content: this.translateService.instant('MM.fault.import.task.successNotification.content'),
              iconName: 'done',
              iconClass: 'nt-success',
              buttonText: this.translateService.instant('MM.fault.import.task.successNotification.refresh'),
              buttonAction: async () => {
                this.onRefreshClicked.emit();
              }
            });
            notification.config = {duration: 1000000, showImmediately: true};

            this.notificationService.notify(ExtendedNotificationComponent, notification);
            break;

          case TaskStatusEnum.canceled:
            delete this.importTasks[task.id];
            break;

          case TaskStatusEnum.failed:
            delete this.importTasks[task.id];

            this.notificationService.error(this.translateService.instant('MM.fault.import.task.errorNotification.content'),
              this.translateService.instant('MM.fault.import.task.errorNotification.title'));
            break;
        }
      });
  }

  registerTask(task: Task) {
    if (!this.importTasks.hasOwnProperty(task.id)) {
      this.importTasks[task.id] = task;
    }

  }

}
